import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ShapeResponse } from '../model/shape.model';

@Injectable({
  providedIn: 'root'
})
export class ShapeService {

  constructor(
    private http: HttpClient
  ) { }
  baseUrl = environment.baseUrl;

  public listarShapesFazendasPorCliente(clienteId: number): Observable<ShapeResponse> {
    const url = `${this.baseUrl}v2/shapes-fazendas/${clienteId}`;
    return this.http.get<ShapeResponse>(url);
  }
}
